import { useQuery } from '@tanstack/react-query';
import { fetchEntitiesCount } from './Admin.services.ts';
import { useMsal } from '@azure/msal-react';

export const useService = () => {
  const { accounts } = useMsal();
  const hasAccount = accounts.length > 0;

  const { data: entities } = useQuery({
    queryKey: ['entitiesCount'],
    queryFn: fetchEntitiesCount,
    enabled: hasAccount,
    retry: false,
  });
  return { entities };
};